export default __webpack_public_path__ + "static/media/Multichain Maxi.107e9292.png";